import React from 'react';
import { RadioBlock, RadioIcon } from './partials';
export var Radio = function Radio(_ref) {
  var id = _ref.id,
    name = _ref.name,
    value = _ref.value,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    handleChange = _ref.handleChange,
    onChange = _ref.onChange,
    children = _ref.children,
    checked = _ref.checked;
  var handleChangeFn = handleChange ? handleChange : onChange;
  return React.createElement(RadioBlock, {
    $isChecked: checked
  }, React.createElement("input", {
    type: "radio",
    id: id,
    name: name,
    value: value,
    onChange: handleChangeFn,
    required: required,
    checked: checked
  }), React.createElement("label", {
    htmlFor: id
  }, React.createElement(RadioIcon, {
    size: 15,
    strokeWidth: 2
  }), children));
};